export class AreaActiveDirectoryModel  {
  public phone: string; 
  public notes: string; 
}
